import { useTheme } from "styled-components";

export const useToastsTheme = () => {
    const theme = useTheme();
    const getCurrentTheme = () =>theme?.app?.backgroundColor === '#2A3034';

    return {
        darkTheme: getCurrentTheme(),
    }
}
import { useTheme } from "styled-components";

export const useToastsTheme = () => {
    const theme = useTheme();
    const getCurrentTheme = () =>theme?.app?.backgroundColor === '#2A3034';

    return {
        darkTheme: getCurrentTheme(),
    }
}
